<template>
  <e-chart :options="chartOptions" autoresize />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/grid'

export default {
  components: {
    'e-chart': ECharts,
  },
  props: {
    observedData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['最高気温', '最低気温'],
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: [
          {
            type: 'value',
            name: '気温',
            position: 'left',
          },
        ],
        series: [
          {
            name: '最高気温',
            type: 'line',
            yAxisIndex: 0,
            data: [],
          },
          {
            name: '最低気温',
            type: 'line',
            yAxisIndex: 0,
            data: [],
          },
        ],
      },
    }
  },
  mounted() {
    this.processData(this.observedData)
  },
  methods: {
    processData(observedData) {
      this.chartOptions.xAxis.data = observedData.time
      this.chartOptions.series[0].data = observedData.temperature_2m_max
      this.chartOptions.series[1].data = observedData.temperature_2m_min
    },
  },
  // FIXME
  // 現在未使用。redrawするタイミングが現在のデータ構造だと難しい。2024.01.24
  redraw() {
    if (this.observedData) {
      this.processData(this.observedData)
    }
  },
}
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 30vh;
}
</style>
